import { render, staticRenderFns } from "./SPRRadioList.vue?vue&type=template&id=104958de"
import script from "./SPRRadioList.vue?vue&type=script&lang=ts"
export * from "./SPRRadioList.vue?vue&type=script&lang=ts"
import style0 from "./SPRRadioList.vue?vue&type=style&index=0&id=104958de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports